import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
// import { axiosInstnace as Axios } from "../../util/util";
// import { endPoints } from "../../config";

const DSATermsPopup = (props) => {
  const closePopup = () => {
    props.hide();
  };
  const handleSubmit = () => {
    props.acceptterms();
  };

  //Return the popup for approve request
  return props.isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval" style={{ width: "125%" }}>
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  TRADE PARTNER DIGITAL TERMS AND CONDITIONS
                </h4>
              </div>
              <div className="approval-content modal-body">
                <div
                  className="popup-container reqst-rejection"
                  style={{ height: "75vh", overflow: "auto" }}
                >
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    This Agreement in the form of terms and conditions
                    constitutes a legally binding agreement made between you,
                    whether personally or on behalf of an entity (&ldquo;
                    <strong>You</strong>&rdquo;) and Reliance Broadcast Network
                    Limited (&ldquo;<strong>Company</strong>&rdquo;, &ldquo;
                    <strong>we</strong>,&rdquo; &ldquo;<strong>us</strong>
                    &rdquo; or &ldquo;<strong>our</strong>&rdquo;), concerning
                    your access to and use of the{" "}
                    <a target="_blank" href="https://buyadsonbigfm.com/">
                      buyadsonbigfm.com
                    </a>{" "}
                    website as well as any other media form, media channel,
                    mobile website or mobile application related, linked, or
                    otherwise connected thereto (collectively, the &ldquo;
                    <strong>Site/Website</strong>&rdquo;).
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Our website -{" "}
                    <a target="_blank" href="https://buyadsonbigfm.com/">
                      buyadsonbigfm.com
                    </a>{" "}
                    is a platform that will help advertisers make requests for
                    jingles, strategize media plans, place orders and transact
                    online. With regular and timely upgrades, the website has an
                    easy-to-use interface that enhances the customer experience.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Our website -{" "}
                    <a
                      target="_blank"
                      href="https://buyadsonbigfm.com/tp/login"
                    >
                      buyadsonbigfm.com/tp/login
                    </a>{" "}
                    is a module or a sub-site of{" "}
                    <a target="_blank" href="https://buyadsonbigfm.com/">
                      buyadsonbigfm.com
                    </a>{" "}
                    platform through which you can register as a &ldquo;
                    <strong>Trade Partner</strong>&rdquo; and help advertisers
                    to make requests for jingles, strategize media plans, place
                    orders and transact online on{" "}
                    <a target="_blank" href="https://buyadsonbigfm.com/">
                      buyadsonbigfm.com
                    </a>{" "}
                    in lieu of an incentive. With regular and timely upgrades,
                    the website has an easy-to-use interface that enhances the
                    customer experience.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    You agree that by accessing the Site, You have read,
                    understood, and thereby agree to be bound by all of these
                    Terms and Conditions. If You do not agree with all of these
                    Terms and Conditions, then You are expressly prohibited from
                    using the Site and You must discontinue use immediately.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Supplemental terms and conditions or documents that may be
                    posted on the Site from time to time are hereby expressly
                    incorporated herein by reference. We reserve the right, in
                    our sole discretion, to make changes or modifications to
                    these Terms and Conditions at any time and for any reason.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    We shall intimate You of any changes by updating the
                    &ldquo;Last updated&rdquo; date of these Terms and
                    Conditions, and You waive any right to receive specific
                    notice of such change.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    It is your responsibility to periodically review these Terms
                    and Conditions to stay informed of any updates. You will be
                    subject to, and will be deemed to have been made aware of
                    and to have accepted, the changes in any revised Terms and
                    Conditions by your continued use of the Site after the date
                    such revised Terms and Conditions are posted.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    The information provided on the Site is not intended for
                    distribution to or use by any person or entity in any
                    jurisdiction or country where such distribution or use would
                    be contrary to law or regulation or which would subject us
                    to any registration requirement within such jurisdiction or
                    country.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    Accordingly, those persons who choose to access the Site
                    from other locations do so on their own initiative and are
                    solely responsible for compliance with local laws, if and to
                    the extent local laws are applicable.&nbsp;
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    This Trade Partner Agreement is made and entered into and
                    agreed upon by you, either an individual or an entity, and
                    any associated affiliates (&ldquo;<strong>You</strong>
                    &rdquo;) and Reliance Broadcast Network Limited (&ldquo;
                    <strong>Company</strong>&rdquo;) for You to help
                    advertisers/agencies to buy ad-spots to broadcast their
                    content on the radio channel owned by the Company subject to
                    such conditions as are set out hereinbelow in lieu of an
                    incentive as detailed in Clause 5 hereunder.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    The Company and You are hereinafter jointly referred to as
                    &ldquo;<strong>Parties</strong>&rdquo; and individually as
                    &ldquo;<strong>Party</strong>&rdquo;.
                  </p>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    <strong>
                      NOW, THEREFORE THE PARTIES HERETO INTENDING TO BE LEGALLY
                      BOUND IN CONSIDERATION OF MUTUAL AGREEMENTS AND COVENANTS
                      CONTAINED HEREIN DO HEREBY AGREE AS FOLLOWS:
                    </strong>
                  </p>
                  <ol
                    style={{
                      fontSize: "14px",
                      textAlign: "justify",
                      marginLeft: "35px",
                      marginTop: "15px",
                      marginRight: "10px",
                      fontWeight: "bold",
                    }}
                  >
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        <b>
                          <u>DEFINITIONS:</u>
                        </b>
                        <ol
                          style={{
                            marginLeft: "35px",
                            marginTop: "15px",
                          }}
                        >
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Advertiser</strong>&rdquo; shall mean
                            a person, firm, company, or any other organization
                            whose products, goods or services are the subject
                            matter of the Advertising Copy for payment of the
                            Advertising Fee under this Agreement.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Advertising Copy</strong>&rdquo;
                            shall mean any advertising material and content
                            proposed to be included in any advertisement to be
                            supplied by &ldquo;You&rdquo; and/or produced by
                            Company for broadcast on the Station.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Advertising Fee</strong>&rdquo; shall
                            have the meaning set out in the individual Deal
                            Agreements/Release Order which shall form an
                            integral part of the Agreement.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Agreement</strong>&rdquo; shall mean
                            the Deal Agreement/Release Order (&ldquo;RO&rdquo;)
                            together with these Standard Terms and Conditions
                            and all annexures hereto and shall include all
                            modifications, alterations, additions or deletions
                            thereto agreed between the Parties in writing after
                            the date of this Agreement.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Deal Agreement/Release Order</strong>
                            &rdquo; shall mean individual deals which shall be
                            signed in addition to this Agreement.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>New Business</strong>&rdquo; means
                            business, commercial opportunity, advertisement
                            orders, revenue channels, sponsorship which hold a
                            revenue value from Clients/Advertisers with whom we
                            have not dealt with in terms of monetary value
                            and/or commercial transaction at all and/or
                            immediate preceding one year of date of execution of
                            this Agreement.. For the avoidance of doubt, New
                            Business shall not include existing
                            Clients/Advertisers which are in active business
                            with RBNL, which will be communicated to You by Us
                            from time to time.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            <strong>&ldquo;Product&rdquo; </strong>means
                            Advertising space, various running spots at Radio
                            Station, FCT and Non-FCT elements sponsorship of any
                            Program/Show at Radio Station of RBNL and/or any
                            other services/product of RBNL
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Station</strong>&rdquo; shall mean
                            the radio station/s operated by the Company, its
                            affiliates and/or licensors operated under the
                            licenses obtained from the Government of India and
                            specified in the Deal Agreement.
                          </li>

                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            &ldquo;<strong>Trade Partner</strong>&rdquo;- shall
                            mean Individual or Company, including its
                            representatives, team, resources, associates, and
                            permitted assigns.
                          </li>
                        </ol>
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        You shall furnish relevant details in the Know Your
                        Customer (<strong>&ldquo;KYC&rdquo;</strong>) made
                        available on the Website, duly filled, to the Company.
                        You shall be responsible to intimate the Company of any
                        changes in the details of KYC provided, as soon as such
                        changes occur and/or become effective, whichever is
                        earlier. Though inserting the GST details of the Agency/
                        Advertiser is not mandatory, You shall note that they
                        will not be eligible for GST ITC if they choose to not
                        furnish such details in the KYC screen. You hereby
                        represent and warrant that any and all information
                        provided by You, before, during and after execution of
                        this Agreement is true to the best of your knowledge and
                        belief and that you have not intentionally withheld
                        information or furnished false information for any
                        reason whatsoever.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        You acknowledge that any damage or loss suffered by You
                        or the Company due to false information published by You
                        shall be your sole liability and You shall keep the
                        Company indemnified and harmless against any claim, cost
                        or damages arising out of the same.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        <b>
                          <u>YOUR OBLIGATIONS:</u>
                        </b>
                        <ol
                          style={{
                            marginLeft: "35px",
                            marginTop: "15px",
                          }}
                        >
                          <p
                            style={{
                              marginBottom: "10px",
                              marginLeft: "-35px",
                            }}
                          >
                            You shall be the strategic alliance of RBNL with a
                            purpose to generate New Business opportunities,
                            initiatives, flow of revenue, by marketing and
                            selling our Products for Radio Station/(s). We shall
                            provide authorized list of Products to be sold by
                            You from time to time in written and we reserve the
                            right to add and subtract number of Products as per
                            Our discretion. Following are the list of ancillary
                            services to be provided by You, to fulfil your
                            obligations under this Agreement in favour of Us:
                          </p>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Identify potential New Business opportunities by
                            conducting pre-analysis of potential customers.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Co-coordinating joint strategy as per current and
                            future scenario, planning, sales initiates, create
                            business model to secure such New Business
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Provide complete data base and report with respect
                            to strategy, prospective Advertiser details, all
                            information data related to marketing, along with
                            prospective revenue streams from thereof on a
                            periodic basis to us upon request from Us.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Assist Advertisers to create and submit payment on{" "}
                            <a href="https://www.buyadsonbigfm.com">
                              https://www.buyadsonbigfm.com
                            </a>{" "}
                            portal including payments.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Ensure that the advertisers enter the email id used
                            by You as the login id on{" "}
                            <a href="http://www.buyadsonbigfm.com/tp/login">
                              https://buyadsonbigfm.com/tp/login
                            </a>{" "}
                            as the &ldquo;Sales Representative ID&rdquo; in the
                            campaign creation screen on the https://
                            <a href="http://www.buyadsonbigfm.com">
                              buyadsonbigfm.com
                            </a>
                            portal.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Raise all support queries through the support portal
                            link available on the{" "}
                            <a href="https://buyadsonbigfm.com/tp/login">
                              https://buyadsonbigfm.com/tp/login
                            </a>{" "}
                            portal.
                          </li>
                        </ol>
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        <b>
                          <u>INCENTIVE ACCRUAL & PAYMENT TERMS:</u>
                        </b>
                        <ol
                          style={{
                            marginLeft: "35px",
                            marginTop: "15px",
                          }}
                        >
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Incentive accrual will be as per the terms &amp;
                            conditions displayed on the portal{" "}
                            <a href="https://www.buyadsonbigfm.com/tp/terms">
                              https://www.buyadsonbigfm.com/tp/terms
                            </a>
                            .
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            We reserve the right to add, change or remove the
                            incentive terms and conditions any time during the
                            term of this agreement which will be applicable for
                            calculation of incentives for any campaigns booked
                            by advertiser through the assistance of You after
                            the change of terms and conditions. We shall
                            communicate all such changes to You through an email
                            communication or a prominent display on the Trade
                            Partner portal.{" "}
                            <a href="https://buyadsonbigfm.com/tp/login">
                              https://buyadsonbigfm.com/tp/login
                            </a>
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Above mentioned amount as payable by Us shall be
                            subject to deduction of applicable taxes.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            You must ensure that the advertiser enters correct
                            email id (through which the You have registered on
                            the{" "}
                            <a href="https://buyadsonbigfm.com/tp/login">
                              https://buyadsonbigfm.com/tp/login
                            </a>
                            &rdquo;) in the field &ldquo;BIG FM Sales
                            Representative ID&rdquo; of the campaign creation
                            screen in order to account the incentive accrued in
                            favour of You.
                          </li>
                        </ol>
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        Both Parties represent and warrant to have the requisite
                        right, power and authority necessary to enter into this
                        Agreement and that this Agreement shall be legally
                        binding on all/both Parties.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        <u>
                          You hereby warrant, represent, and undertake to the
                        </u>
                        Company that:
                        <ol
                          style={{
                            marginLeft: "35px",
                            marginTop: "15px",
                          }}
                        >
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            You will fully indemnify and keep the Company and
                            its respective affiliates and licensors fully
                            indemnified against all actions, proceedings, costs,
                            damages, expenses, penalties, claims, demands and
                            liabilities howsoever arising from any breach of
                            Your warranties, obligations or terms contained in
                            this Agreement or in any manner whatsoever as a
                            consequence of the use, recording transmission or
                            broadcasting in the form submitted or prescribed of
                            any Advertising Copy or matter supplied by or
                            transmitted for or through You, or any third party
                            claim;
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            You shall not hold the Company responsible for any
                            product/ service liability of any kind. It is
                            clarified that Company is a mere broadcaster of
                            Advertisements.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            You hereby grant to the Company, the non-exclusive
                            right to use your logos, trade names and trademarks
                            in the performance of its obligations during the
                            term of this Agreement and in the Company’s
                            advertising sales marketing materials. You represent
                            and warrant that You have the authority to grant
                            such rights.{" "}
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            You hereby agree to hold and continue to hold the
                            Company, its officers, employees fully indemnified
                            without any limit against any claim, cost, expenses,
                            damages and/ or penalty that the Company may suffer
                            on account of the telecasting/ airing of the
                            Advertising Material and/ or the program and against
                            any claims or proven actual loss that may be
                            suffered due to false product claims or any other
                            non-compliance to applicable laws.
                          </li>
                        </ol>
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        The Parties agree to keep the terms of this Agreement
                        strictly confidential at all times. Except to the extent
                        authorized by this Agreement and any requirement under
                        law, during the term and following the expiration or
                        termination of the agreement, the Parties shall not
                        disclose, publish or make available any proprietary
                        information including but not limited to rates, time
                        bands, costs etc. to any third party and shall not sell,
                        transfer or otherwise use or exploit any such
                        Proprietary information disclosed to them.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        No Party shall be liable to any other for any loss of
                        business, revenue, or profits, or any indirect or
                        consequential loss or damage whatsoever arising out of
                        or in connection with the performance or non-performance
                        of this Agreement.{" "}
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        You shall not assign, delegate, or license your rights
                        in whole or in part under this Agreement without the
                        prior written consent of the Company. The Company may
                        assign, delegate or license its rights and obligations
                        under this Agreement at any time.{" "}
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        The Company shall not be liable for damages for any
                        delay or failure to perform its obligations hereunder,
                        if such delay or failure is due to causes beyond its
                        control and without its negligence, including, without
                        limitation, acts of God or state or of any sovereign
                        authority or any public enemy, or acts mandated by any
                        applicable laws, regulation or order (whether valid or
                        invalid) of any governmental body/ ministry/ authority.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        This Agreement and the rights and obligations of the
                        Parties hereunder shall be construed, interpreted, and
                        enforced in accordance and governed by the existing laws
                        of India.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        In the event of any claims, disputes, questions,
                        involving the Parties and arising out of or in
                        connection with this Agreement, or the execution,
                        interpretation, validity, performance breach or
                        termination hereof shall be resolved by the Parties
                        amicably as far as possible between the duly authorized
                        representatives of the Parties hereto within 30 (thirty)
                        calendar days of arising thereof. If the Parties fail to
                        arrive at an amicable resolution, the Courts of Mumbai
                        shall have exclusive jurisdiction over such claims,
                        disputes and/or questions.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        This Agreement does not create any partnership or agency
                        relationship between the Company and You, and neither
                        the Company, nor You shall be entitled to act as the
                        other’s agent or represent or hold itself out in any way
                        as representing or acting on behalf of the other unless
                        such representation or action is specifically authorized
                        in and voice in writing by the other.
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        <b>
                          <u>TERM AND TERMINATION:</u>
                        </b>
                        <ol
                          style={{
                            marginLeft: "35px",
                            marginTop: "15px",
                          }}
                        >
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            The term of this Agreement shall be deemed to be
                            effective from date of execution till the same is
                            not explicitly terminated by Company.{" "}
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Company may terminate this Agreement:
                            <ol
                              style={{
                                marginLeft: "35px",
                                marginTop: "15px",
                              }}
                            >
                              <li
                                style={{
                                  listStyle: "lower-roman",
                                  marginBottom: "10px",
                                }}
                              >
                                By giving 15 days’ notice without assigning any
                                reasons.
                              </li>{" "}
                              <li
                                style={{
                                  listStyle: "lower-roman",
                                  marginBottom: "10px",
                                }}
                              >
                                In case of irregular or unsatisfactory services
                                by You, by giving 7 days prior notice, if You
                                fails to cure the said irregularity during the
                                aforesaid notice period.
                              </li>{" "}
                              <li
                                style={{
                                  listStyle: "lower-roman",
                                  marginBottom: "10px",
                                }}
                              >
                                With an immediate effect, if there is a breach
                                by You of any term, obligations,
                                representations, warranties including terms of
                                Confidentiality obligations, of this Agreement.
                              </li>
                            </ol>
                          </li>
                        </ol>
                      </p>{" "}
                    </li>
                    <li style={{ listStyle: "decimal", marginBottom: "10px" }}>
                      <p style={{ fontWeight: "normal" }}>
                        <b>
                          <u>EFFECT OF TERMINATION/EXPIRY:</u>
                        </b>
                        <ol
                          style={{
                            marginLeft: "35px",
                            marginTop: "15px",
                          }}
                        >
                          <p
                            style={{
                              marginBottom: "10px",
                              marginLeft: "-35px",
                            }}
                          >
                            Notwithstanding any other rights and remedies
                            provided in this Agreement, on termination /expiry
                            of this Agreement, Parties shall adhere to the
                            following:
                          </p>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            <u>No representation:</u> Neither Party will
                            represent nor intentionally or otherwise commit any
                            act(s) as would have a third party to believe
                            association of the Party with the other Party.
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            <u>Existence of obligations:</u> Upon the expiration
                            or termination of this Agreement, all licenses and
                            rights granted by Us to You under this Agreement
                            shall terminate/cease immediately, (in case of
                            termination on the date of notice period), but it
                            will not affect any obligation or right of either
                            Party having accrued under this Agreement, prior to
                            the expiration or termination of this Agreement.
                            Such expiration or termination shall be without
                            prejudice to any liabilities or rights of either
                            Party to the other Party existing at the date of
                            expiration or termination of this Agreement.{" "}
                          </li>
                          <li
                            style={{
                              listStyle: "lower-alpha",
                              marginBottom: "10px",
                            }}
                          >
                            Upon the expiration or termination of this
                            Agreement, You shall forthwith cease and not use any
                            Confidential Proprietary information granted under
                            this Agreement by us. Upon expiry or termination of
                            this Agreement, You agree to promptly return, or at
                            our request, destroy (and provide confirmation of
                            such destruction in written form, of all
                            Confidential Information). Clause nos.7,8,9,10,11,13
                            and all other clause which nature require survival
                            shall survive termination and/or expiry of this
                            Agreement for any reason. All other rights and
                            obligations of the Parties under this Agreement
                            shall expire upon termination and/expiry of this
                            Agreement, except that all obligations accrued
                            hereunder prior to termination or expiration.{" "}
                          </li>
                        </ol>
                      </p>
                    </li>
                  </ol>
                  <p
                    className="reqst-para approval-reqst"
                    style={{
                      textAlign: "justify",
                      marginLeft: "15px",
                      marginRight: "10px",
                      marginTop: "15px",
                    }}
                  >
                    By clicking on “I Agree” button below, You hereby waive any
                    and all defences you may have based on the electronic form
                    of these Terms and Conditions and the lack of signing by the
                    Parties hereto to execute in Agreement setting out the Terms
                    and Conditions.
                  </p>
                  <div className="confirn-btn">
                    <button className="cancel-reqst" onClick={props.hide}>
                      Decline
                    </button>
                    <button className="confirm-reqst" onClick={handleSubmit}>
                      I Agree
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default DSATermsPopup;



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/termsandcond.js